<template>
  <div class="customTabs">
    <el-tabs
      v-if="$mq === 'laptop' || $mq === 'desktop'"
      v-model="defaultLocal"
      type="border-card"
      class="mainCard clear-tabs"
      stretch
      lazy
    >
      <slot name="subtitle"></slot>
      <el-tab-pane v-if="$slots.title1 || $slots.content1">
        <div slot="label">
          <slot
            v-if="$slots.title1"
            name="title1"
          ></slot>
        </div>

        <slot
          v-if="$slots.content1"
          name="content1"
        ></slot>
      </el-tab-pane>

      <el-tab-pane v-if="$slots.title2 || $slots.content2">
        <div slot="label">
          <slot
            v-if="$slots.title2"
            name="title2"
          ></slot>
        </div>

        <slot
          v-if="$slots.content2"
          name="content2"
        ></slot>
      </el-tab-pane>

      <el-tab-pane v-if="$slots.title3 || $slots.content3">
        <div slot="label">
          <slot
            v-if="$slots.title3"
            name="title3"
          ></slot>
        </div>

        <slot
          v-if="$slots.content3"
          name="content3"
        ></slot>
      </el-tab-pane>
    </el-tabs>

    <div
      v-else
      class="mobile"
    >
      <div
        v-if="$slots.title1"
        class="title"
      >
        <slot name="title1"></slot>
      </div>

      <div
        v-if="$slots.content1"
        class="content"
      >
        <slot name="content1"></slot>
      </div>

      <div
        v-if="$slots.title2"
        class="title"
      >
        <slot name="title2"></slot>
      </div>

      <div
        v-if="$slots.content2"
        class="content"
      >
        <slot name="content2"></slot>
      </div>
      <div
        v-if="$slots.title3"
        class="title"
      >
        <slot name="title3"></slot>
      </div>

      <div
        v-if="$slots.content3"
        class="content"
      >
        <slot name="content3"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    defaultTab: {
      type: String,
      default: '0',
    },
  },

  computed: {
    defaultLocal: {
      get() {
        return this.defaultTab;
      },
      set(newValue) {
        this.$emit('update:selected', newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.customTabs {
  .mobile {
    .title {
      color: var(--themeFontColor);
      padding: 0 10px;
    }
  }
}
</style>

<style lang="scss">
  .customTabs {
    .el-tabs__nav-scroll {
      display: flex;

      .el-tabs__nav {
        align-items: stretch;

        .el-tabs__item {
          height: 100%;

          & > div {
            height: 100%;

            & > div {
              height: 100%;
            }
          }

          .value {
            display: flex;
            height: calc(100% - 30px);
            justify-content: center;
            align-items: center;
            padding: 5px 0;
            box-sizing: border-box;
            white-space: normal;
            word-break: break-word;
            line-height: 18px;
          }
        }
      }
    }
  }
</style>
